module.exports = __webpack_public_path__ + "img/piggy-currency-guide-1.fef1254e.png";